<template>
  <div class="main">
    <div v-for="item in this.data" :key="item.id" class="board">
      <div class="icon">
        <img :src="item.icon" alt="" />
      </div>
      <div>
        <span class="value">{{ item.value }}</span>
        <span class="name">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Array,
  },
};
</script>

<style scoped lang="scss">
.main {
  display: flex;
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 50px;

  .board {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .icon {
      flex-shrink: 0;
      margin-bottom: 8px;
    }

    & > div {
      display: flex;
      flex-direction: column;

      .value {
        font-family: SF Pro Display;
        font-weight: 600;
        font-size: 24px;
        line-height: 24px;
        color: #000000;
        margin-bottom: 8px;
      }

      .name {
        font-family: SF Pro Display;
        font-weight: bold;
        font-size: 15px;
        line-height: 20px;
        color: #000000;
      }
    }
  }
}

@media (max-width: 1024px) {
  .main {
    width: 360px;
    background: none;
    flex-direction: column;
    padding: 0;

    .board {
      padding: 32px;
      background: #ffffff;
      border-radius: 16px;
      margin-bottom: 8px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .icon {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: #f0f0f0;
        margin-right: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>